export default "__VITE_ASSET__84559ded__"